/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1RequestStatus } from './V1RequestStatus'
import {
    V1RequestStatusFromJSON,
    V1RequestStatusFromJSONTyped,
    V1RequestStatusToJSON,
    V1RequestStatusToJSONTyped
} from './V1RequestStatus'

/**
 *
 * @export
 * @interface V1StatusUpdatePayload
 */
export interface V1StatusUpdatePayload {
    /**
     *
     */
    status: V1RequestStatus
    /**
     *
     */
    programmeId?: string
    /**
     *
     */
    reason?: string
}

/**
 * Check if a given object implements the V1StatusUpdatePayload interface.
 */
export function instanceOfV1StatusUpdatePayload(
    value: object
): value is V1StatusUpdatePayload {
    if (!('status' in value) || value['status'] === undefined) return false
    return true
}

export function V1StatusUpdatePayloadFromJSON(
    json: any
): V1StatusUpdatePayload {
    return V1StatusUpdatePayloadFromJSONTyped(json, false)
}

export function V1StatusUpdatePayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1StatusUpdatePayload {
    if (json == null) {
        return json
    }
    return {
        status: V1RequestStatusFromJSON(json['status']),
        programmeId:
            json['programmeId'] == null ? undefined : json['programmeId'],
        reason: json['reason'] == null ? undefined : json['reason']
    }
}

export function V1StatusUpdatePayloadToJSON(json: any): V1StatusUpdatePayload {
    return V1StatusUpdatePayloadToJSONTyped(json, false)
}

export function V1StatusUpdatePayloadToJSONTyped(
    value?: V1StatusUpdatePayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        status: V1RequestStatusToJSON(value['status']),
        programmeId: value['programmeId'],
        reason: value['reason']
    }
}
